import dayjs from 'dayjs';
import React from 'react';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import useGet from '../../helpers/hooks/useGet';
import MundiBidsList from './mundi-bids-list';
import useGetAuthed from '../../helpers/hooks/useGetAuthed';

function MundiBids(props) {
  const [bids, bidsError, bidsLoading] = useGetAuthed(
    `/seller-ads/${props.match.params.id}/bids?filter=${encodeURIComponent(
      JSON.stringify({ include: [{ relation: 'buyer' }] })
    )}`,
    true
  );
  const [ad, adError, adLoading] = useGetAuthed(
    `/seller-ads/${props.match.params.id}?filter=${encodeURIComponent(
      JSON.stringify({
        include: [
          { relation: 'farmer' },
          { relation: 'vegetable' },
          { relation: 'district' },
        ],
      })
    )}`,
    true
  );

  return (
    <div className='page-content'>
      <Container fluid>
        <Card>
          <CardBody>
            <Row>
              <Col>
                <img
                  style={{ maxHeight: '205px' }}
                  src={ad?.image}
                  alt=''
                  className='rounded card-img'
                />
              </Col>
              <Col className='d-flex flex-column justify-content-between'>
                <h4>Vegetable: {ad?.vegetable.name}</h4>
                <h4>Farmer: {ad?.farmer.name}</h4>
                <h4>Phone: {ad?.farmer.phone}</h4>
                <h4>District: {ad?.district.name}</h4>
              </Col>
              <Col className='d-flex flex-column justify-content-between'>
                <h4>Created At: {dayjs(ad?.createdAt).format('DD/MM/YYYY')}</h4>
                <h4>Weight: {ad?.weightUnit + ' ' + ad?.weight}</h4>
                <h4>Price: {ad?.price}</h4>
                <h4>Bids: {bids?.length}</h4>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <Row>
              <Col>
                <MundiBidsList bids={bids} ad={ad} />
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
}

export default MundiBids;
